import React, { useState, useCallback } from "react";
import {
  Box,
  TableCell,
  TableRow,
  Collapse,
  IconButton,
  Tooltip,
  Switch,
  Typography,
  Card,
  CardContent,
  Grid,
  Hidden,
} from "@material-ui/core";
import Detail from "./DetailInstaller";
import Modal from "../../components/Modal";
import { makeStyles } from "@material-ui/core/styles";
import {
  ChevronDown as ChevronDownIcon,
  ChevronUp as ChevronUpIcon,
} from "react-feather";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  buttons: {
    "& > *": {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      [theme.breakpoints.down("xs")]: {
        marginLeft: 0,
      },
    },
  },
  collapsePanel: {
    borderTop: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: "rgba(0,0,0,0.012)",
  },
  card: {
    margin: "12px 0",
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
    border: "1px solid rgba(0,0,0,0.06)",
  },
  text: {
    fontSize: "15px",
  },
  info: {
    maxWidth: "15rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

const Row = ({ item, headCells, onSwitchAction = () => {} }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const getInfo = useCallback(
    (id) => {
      switch (id) {
        case "country":
        case "city":
        case "cellular_number":
          return (
            <Typography className={clsx(classes.info, classes.text)}>
              {item.profile[id]}
            </Typography>
          );
        case "first_name":
          return (
            <Typography className={clsx(classes.info, classes.text)}>
              {item[id]} {item.last_name}
            </Typography>
          );
        case "connect":
          return (
            <div className={classes.buttons}>
              <Tooltip title="">
                <Switch
                  checked={item.is_active}
                  onChange={(event) =>
                    onSwitchAction(item.id, event.target.checked)
                  }
                  color="primary"
                />
              </Tooltip>
              <Tooltip title="Detail">
                <IconButton
                  size="small"
                  onClick={() => setOpenModal(!openModal)}
                >
                  {openModal ? <ChevronUpIcon /> : <ChevronDownIcon />}
                </IconButton>
              </Tooltip>
            </div>
          );
        default:
          return (
            <Typography className={clsx(classes.info, classes.text)}>
              {item[id]}
            </Typography>
          );
      }
    },
    [
      item,
      openModal,
      classes.buttons,
      classes.info,
      classes.text,
      onSwitchAction,
    ],
  );

  return (
    <>
      <Hidden xsDown>
        <TableRow key={item.id}>
          <TableCell>
            {item.first_name} {item.last_name}
          </TableCell>
          <TableCell>{item.email}</TableCell>
          <TableCell>{item.username}</TableCell>
          <TableCell>{item.profile.country}</TableCell>
          <TableCell>{item.profile.city}</TableCell>
          <TableCell>{item.profile.cellular_number}</TableCell>
          <TableCell>
            <div className={classes.buttons}>
              <Tooltip title="">
                <Switch
                  checked={item.is_active}
                  onChange={(event) =>
                    onSwitchAction(item.id, event.target.checked)
                  }
                  color="primary"
                />
              </Tooltip>
              <Tooltip title="Detail">
                <IconButton size="small" onClick={() => setOpen(!open)}>
                  {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
                </IconButton>
              </Tooltip>
            </div>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box className={classes.collapsePanel}>
                <Detail item={item} />
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </Hidden>
      <Hidden smUp>
        <Card className={classes.card}>
          <CardContent>
            {headCells?.map((headCell) => (
              <Grid container key={headCell.id}>
                <Grid item xs={4}>
                  <Typography variant="h5">{headCell.label}</Typography>
                </Grid>
                <Grid item xs={8}>
                  {getInfo(headCell.id, item)}
                </Grid>
              </Grid>
            ))}
          </CardContent>
        </Card>
      </Hidden>
      {openModal ? (
        <Modal
          fullScreen={true}
          title={item.first_name + " " + item.last_name}
          onClose={() => setOpenModal(false)}
          open={openModal}
        >
          <Detail item={item} />
        </Modal>
      ) : null}
    </>
  );
};

export default Row;
